<template>
    <c-input
        :id="id"
        v-model="model"
        class="c-datepicker-wrapper"
        type="date"
        :label="label"
        :input-class="inputClass"
        :label-class="labelClass"
        :input-size="inputSize"
        :disabled="disabled"
        :placeholder="placeholder"
        :required="required"
        :min="minValue"
        :max="maxValue"
        :error="error"
        :error-msg="errorMsg"
    />
</template>

<script setup lang="ts">
import { HtmlHTMLAttributes, InputHTMLAttributes, computed } from 'vue';
import CInput from './CInput.vue';

type InputSize = 'lg' | 'md' | 'sm' | 'xs';

const props = defineProps<{
    value?: Date | string;
    id?: InputHTMLAttributes['id'];
    inputClass?: InputHTMLAttributes['class'];
    disabled?: boolean;
    required?: boolean;
    min?: Date | string;
    max?: Date | string;
    placeholder?: HtmlHTMLAttributes['placeholder'];
    label?: string;
    labelClass?: HtmlHTMLAttributes['class'];
    error?: boolean;
    errorMsg?: string;
    inputSize?: InputSize;
}>();

const emit = defineEmits<{
    (event: 'input', value: Date | undefined): void;
}>();

const formatToDateString = (date?: Date | string) => {
    if (date instanceof Date) {
        return new Intl.DateTimeFormat('en-CA').format(date); // 'yyyy-MM-dd';
    }
    return date;
};

const model = computed({
    get: () => {
        return formatToDateString(props.value);
    },
    set: (value: string | undefined) => {
        const _value = value ? new Date(value) : undefined;
        emit('input', _value);
    }
});

const minValue = computed(() => formatToDateString(props.min));
const maxValue = computed(() => formatToDateString(props.max));
</script>
